module.exports = __webpack_public_path__ + "img/v_scud.9bf20e7b.svg";